// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4b348d71","455":"8c6b4067","644":"5d97dd17"}[chunkId] + ".chunk.js";
};